// Simple i18n mock for legacy components
// This provides basic translation functionality for components that expect it

const messages = {
  es: {
    translations: {
      flowBuilder: {
        addText: "Agregar Texto",
        editText: "Editar Texto",
        addMenu: "Agregar Menú",
        editMenu: "Editar Menú",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        add: "Agregar",
        name: "Nombre",
        message: "Mensaje",
        options: "Opciones",
      },
      aiModules: {
        openaiSettings: {
          title: "Configuración de Proveedores IA",
          description: "Configure sus proveedores de servicios de IA",
          stats: {
            configured: "Configurados",
            active: "Activos",
            connected: "Conectados",
            errors: "Errores"
          },
          security: {
            warning: "Las claves API se almacenan de forma segura"
          },
          table: {
            title: "Proveedores",
            empty: "No hay proveedores configurados",
            status: "Estado",
            provider: "Proveedor",
            name: "Nombre",
            apiKey: "Clave API",
            active: "Activo",
            default: "Por defecto",
            defaultModel: "Modelo por defecto",
            capabilities: "Capacidades",
            actions: "Acciones"
          },
          status: {
            pending: "Pendiente",
            connected: "Conectado",
            error: "Error"
          },
          common: {
            yes: "Sí",
            no: "No",
            test: "Probar"
          },
          capabilities: {
            text: "Texto",
            translation: "Traducción",
            image: "Imagen",
            vision: "Visión",
            stt: "Voz"
          },
          toasts: {
            updateSuccess: "Proveedor actualizado correctamente",
            createSuccess: "Proveedor creado correctamente",
            deleteSuccess: "Proveedor eliminado correctamente",
            errorSaving: "Error al guardar proveedor",
            errorDeleting: "Error al eliminar proveedor",
            testSuccess: "Conexión exitosa: {model}",
            testError: "Conexión fallida: {error}",
            errorTesting: "Error al probar conexión"
          },
          modal: {
            titleCreate: "Nuevo Proveedor",
            titleEdit: "Editar Proveedor",
            providerLabel: "Proveedor",
            displayNameLabel: "Nombre para mostrar",
            displayNamePlaceholder: "ej., OpenAI Producción",
            apiKeyLabel: "Clave API",
            apiKeyPlaceholder: "sk-...",
            baseUrlLabel: "URL Base",
            baseUrlPlaceholder: "https://api.openai.com/v1",
            settingsTitle: "Configuración del Modelo",
            defaultModelLabel: "Modelo por defecto",
            defaultModelPlaceholder: "gpt-4o",
            maxTokensLabel: "Tokens máximos",
            temperatureLabel: "Temperatura",
            organizationLabel: "ID de Organización",
            organizationPlaceholder: "org-...",
            activeLabel: "Activo",
            defaultLabel: "Establecer como predeterminado",
            capabilitiesTitle: "Capacidades de IA",
            capabilitiesDescription: "Habilite las capacidades de IA que desea usar",
            textGenerationLabel: "Generación de Texto",
            textGenerationDescription: "Generar texto con IA",
            translationLabel: "Traducción",
            translationDescription: "Traducir texto entre idiomas",
            imageGenerationLabel: "Generación de Imágenes",
            imageGenerationDescription: "Generar imágenes con IA",
            imageAnalysisLabel: "Análisis de Imágenes",
            imageAnalysisDescription: "Analizar imágenes con IA",
            speechToTextLabel: "Voz a Texto",
            speechToTextDescription: "Convertir audio a texto",
            pricingTitle: "Precio de Créditos",
            pricingDescription: "Establecer costos de tokens para cada capacidad",
            pricingTextLabel: "Texto (por solicitud)",
            pricingTranslationLabel: "Traducción (por solicitud)",
            pricingImageGenerationLabel: "Generación de Imágenes",
            pricingImageAnalysisLabel: "Análisis de Imagen (por solicitud)",
            pricingSpeechToTextLabel: "Voz a Texto (por minuto)"
          },
          delete: {
            title: "Eliminar Proveedor",
            message: "¿Está seguro de que desea eliminar este proveedor? Esta acción no se puede deshacer."
          },
          buttons: {
            reload: "Recargar",
            addProvider: "Agregar Proveedor",
            createFirst: "Crea tu primer proveedor",
            cancel: "Cancelar",
            save: "Guardar Cambios",
            create: "Crear Proveedor",
            delete: "Eliminar"
          }
        },
        subplans: {
          title: "Planes de Tokens IA",
          description: "Administrar planes de tokens de IA",
          stats: {
            total: "Total Planes",
            active: "Activos",
            public: "Públicos",
            totalTokens: "Total Tokens"
          },
          table: {
            title: "Planes",
            empty: "No hay planes configurados",
            name: "Nombre",
            tokens: "Tokens",
            used: "Usados",
            remaining: "Restantes",
            price: "Precio",
            active: "Activo",
            public: "Público",
            actions: "Acciones",
            yes: "Sí",
            no: "No"
          },
          pagination: {
            showing: "Mostrando {current} de {total}",
            previous: "Anterior",
            next: "Siguiente",
            page: "Página {current} de {total}"
          },
          modal: {
            titleCreate: "Nuevo Plan",
            titleEdit: "Editar Plan",
            nameLabel: "Nombre del Plan",
            namePlaceholder: "ej., Plan 500 Tokens",
            descriptionLabel: "Descripción",
            descriptionPlaceholder: "Descripción opcional",
            tokensSection: "Configuración de Tokens",
            tokensLabel: "Cantidad de Tokens",
            priceLabel: "Precio (USD)",
            maxAgentsLabel: "Límite de Agentes IA",
            optionsSection: "Opciones",
            activeLabel: "Activo",
            activeHelper: "Hacer este plan disponible",
            publicLabel: "Público",
            publicHelper: "Visible para que las empresas lo compren"
          },
          validation: {
            nameRequired: "El nombre es requerido",
            nameLength: "El nombre no puede exceder 100 caracteres",
            descriptionLength: "La descripción no puede exceder 500 caracteres",
            tokensRequired: "La cantidad de tokens es requerida",
            tokensInvalid: "Los tokens deben ser un entero válido",
            tokensMin: "Los tokens deben ser mayores a 0",
            tokensMax: "Los tokens no pueden exceder 1,000,000",
            priceInvalid: "El precio debe ser un número válido",
            priceMin: "El precio debe ser mayor a 0",
            priceMax: "El precio no puede exceder 99999.99",
            priceDecimals: "El precio puede tener hasta 2 decimales"
          },
          toasts: {
            createSuccess: "Plan creado correctamente",
            updateSuccess: "Plan actualizado correctamente",
            deleteSuccess: "Plan eliminado correctamente",
            errorLoading: "Error al cargar planes",
            errorSaving: "Error al guardar plan",
            errorDeleting: "Error al eliminar plan"
          },
          delete: {
            title: "Eliminar Plan",
            message: "¿Está seguro de que desea eliminar este plan? Esta acción no se puede deshacer."
          },
          buttons: {
            reload: "Recargar",
            new: "Nuevo Plan",
            createFirst: "Crea tu primer plan",
            cancel: "Cancelar",
            save: "Guardar Cambios",
            create: "Crear Plan",
            delete: "Eliminar"
          }
        }
      }
    },
  },
  en: {
    translations: {
      flowBuilder: {
        addText: "Add Text",
        editText: "Edit Text",
        addMenu: "Add Menu",
        editMenu: "Edit Menu",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        add: "Add",
        name: "Name",
        message: "Message",
        options: "Options",
      },
      aiModules: {
        openaiSettings: {
          title: "AI Providers Configuration",
          description: "Configure your AI service providers",
          stats: {
            configured: "Configured",
            active: "Active",
            connected: "Connected",
            errors: "Errors"
          },
          security: {
            warning: "API keys are stored securely"
          },
          table: {
            title: "Providers",
            empty: "No providers configured",
            status: "Status",
            provider: "Provider",
            name: "Name",
            apiKey: "API Key",
            active: "Active",
            default: "Default",
            defaultModel: "Default Model",
            capabilities: "Capabilities",
            actions: "Actions"
          },
          status: {
            pending: "Pending",
            connected: "Connected",
            error: "Error"
          },
          common: {
            yes: "Yes",
            no: "No",
            test: "Test"
          },
          capabilities: {
            text: "Text",
            translation: "Translation",
            image: "Image",
            vision: "Vision",
            stt: "Speech"
          },
          toasts: {
            updateSuccess: "Provider updated successfully",
            createSuccess: "Provider created successfully",
            deleteSuccess: "Provider deleted successfully",
            errorSaving: "Error saving provider",
            errorDeleting: "Error deleting provider",
            testSuccess: "Connection successful: {model}",
            testError: "Connection failed: {error}",
            errorTesting: "Error testing connection"
          },
          modal: {
            titleCreate: "New Provider",
            titleEdit: "Edit Provider",
            providerLabel: "Provider",
            displayNameLabel: "Display Name",
            displayNamePlaceholder: "e.g., OpenAI Production",
            apiKeyLabel: "API Key",
            apiKeyPlaceholder: "sk-...",
            baseUrlLabel: "Base URL",
            baseUrlPlaceholder: "https://api.openai.com/v1",
            settingsTitle: "Model Settings",
            defaultModelLabel: "Default Model",
            defaultModelPlaceholder: "gpt-4o",
            maxTokensLabel: "Max Tokens",
            temperatureLabel: "Temperature",
            organizationLabel: "Organization ID",
            organizationPlaceholder: "org-...",
            activeLabel: "Active",
            defaultLabel: "Set as Default",
            capabilitiesTitle: "AI Capabilities",
            capabilitiesDescription: "Enable the AI capabilities you want to use",
            textGenerationLabel: "Text Generation",
            textGenerationDescription: "Generate text with AI",
            translationLabel: "Translation",
            translationDescription: "Translate text between languages",
            imageGenerationLabel: "Image Generation",
            imageGenerationDescription: "Generate images with AI",
            imageAnalysisLabel: "Image Analysis",
            imageAnalysisDescription: "Analyze images with AI",
            speechToTextLabel: "Speech to Text",
            speechToTextDescription: "Convert audio to text",
            pricingTitle: "Credit Pricing",
            pricingDescription: "Set token costs for each capability",
            pricingTextLabel: "Text (per request)",
            pricingTranslationLabel: "Translation (per request)",
            pricingImageGenerationLabel: "Image Generation",
            pricingImageAnalysisLabel: "Image Analysis (per request)",
            pricingSpeechToTextLabel: "Speech to Text (per minute)"
          },
          delete: {
            title: "Delete Provider",
            message: "Are you sure you want to delete this provider? This action cannot be undone."
          },
          buttons: {
            reload: "Reload",
            addProvider: "Add Provider",
            createFirst: "Create your first provider",
            cancel: "Cancel",
            save: "Save Changes",
            create: "Create Provider",
            delete: "Delete"
          }
        },
        subplans: {
          title: "AI Token Plans",
          description: "Manage AI token plans",
          stats: {
            total: "Total Plans",
            active: "Active",
            public: "Public",
            totalTokens: "Total Tokens"
          },
          table: {
            title: "Plans",
            empty: "No plans configured",
            name: "Name",
            tokens: "Tokens",
            used: "Used",
            remaining: "Remaining",
            price: "Price",
            active: "Active",
            public: "Public",
            actions: "Actions",
            yes: "Yes",
            no: "No"
          },
          pagination: {
            showing: "Showing {current} of {total}",
            previous: "Previous",
            next: "Next",
            page: "Page {current} of {total}"
          },
          modal: {
            titleCreate: "New Plan",
            titleEdit: "Edit Plan",
            nameLabel: "Plan Name",
            namePlaceholder: "e.g., Plan 500 Tokens",
            descriptionLabel: "Description",
            descriptionPlaceholder: "Optional description",
            tokensSection: "Token Settings",
            tokensLabel: "Token Amount",
            priceLabel: "Price (USD)",
            maxAgentsLabel: "AI Agents Limit",
            optionsSection: "Options",
            activeLabel: "Active",
            activeHelper: "Make this plan available",
            publicLabel: "Public",
            publicHelper: "Visible for companies to purchase"
          },
          validation: {
            nameRequired: "Name is required",
            nameLength: "Name cannot exceed 100 characters",
            descriptionLength: "Description cannot exceed 500 characters",
            tokensRequired: "Token amount is required",
            tokensInvalid: "Tokens must be a valid integer",
            tokensMin: "Tokens must be greater than 0",
            tokensMax: "Tokens cannot exceed 1,000,000",
            priceInvalid: "Price must be a valid number",
            priceMin: "Price must be greater than 0",
            priceMax: "Price cannot exceed 99999.99",
            priceDecimals: "Price can have up to 2 decimal places"
          },
          toasts: {
            createSuccess: "Plan created successfully",
            updateSuccess: "Plan updated successfully",
            deleteSuccess: "Plan deleted successfully",
            errorLoading: "Error loading plans",
            errorSaving: "Error saving plan",
            errorDeleting: "Error deleting plan"
          },
          delete: {
            title: "Delete Plan",
            message: "Are you sure you want to delete this plan? This action cannot be undone."
          },
          buttons: {
            reload: "Reload",
            new: "New Plan",
            createFirst: "Create your first plan",
            cancel: "Cancel",
            save: "Save Changes",
            create: "Create Plan",
            delete: "Delete"
          }
        }
      }
    },
  },
  pt: {
    translations: {
      flowBuilder: {
        addText: "Adicionar Texto",
        editText: "Editar Texto",
        addMenu: "Adicionar Menu",
        editMenu: "Editar Menu",
        save: "Salvar",
        cancel: "Cancelar",
        delete: "Excluir",
        add: "Adicionar",
        name: "Nome",
        message: "Mensagem",
        options: "Opções",
      },
      aiModules: {
        openaiSettings: {
          title: "Configuração de Provedores de IA",
          description: "Configure seus provedores de serviços de IA",
          stats: {
            configured: "Configurados",
            active: "Ativos",
            connected: "Conectados",
            errors: "Erros"
          },
          security: {
            warning: "As chaves de API são armazenadas com segurança"
          },
          table: {
            title: "Provedores",
            empty: "Nenhum provedor configurado",
            status: "Status",
            provider: "Provedor",
            name: "Nome",
            apiKey: "Chave API",
            active: "Ativo",
            default: "Padrão",
            defaultModel: "Modelo Padrão",
            capabilities: "Capacidades",
            actions: "Ações"
          },
          status: {
            pending: "Pendente",
            connected: "Conectado",
            error: "Erro"
          },
          common: {
            yes: "Sim",
            no: "Não",
            test: "Testar"
          },
          capabilities: {
            text: "Texto",
            translation: "Tradução",
            image: "Imagem",
            vision: "Visão",
            stt: "Voz"
          },
          toasts: {
            updateSuccess: "Provedor atualizado com sucesso",
            createSuccess: "Provedor criado com sucesso",
            deleteSuccess: "Provedor excluído com sucesso",
            errorSaving: "Erro ao salvar provedor",
            errorDeleting: "Erro ao excluir provedor",
            testSuccess: "Conexão bem-sucedida: {model}",
            testError: "Falha na conexão: {error}",
            errorTesting: "Erro ao testar conexão"
          },
          modal: {
            titleCreate: "Novo Provedor",
            titleEdit: "Editar Provedor",
            providerLabel: "Provedor",
            displayNameLabel: "Nome de Exibição",
            displayNamePlaceholder: "ex., OpenAI Produção",
            apiKeyLabel: "Chave API",
            apiKeyPlaceholder: "sk-...",
            baseUrlLabel: "URL Base",
            baseUrlPlaceholder: "https://api.openai.com/v1",
            settingsTitle: "Configurações do Modelo",
            defaultModelLabel: "Modelo Padrão",
            defaultModelPlaceholder: "gpt-4o",
            maxTokensLabel: "Máximo de Tokens",
            temperatureLabel: "Temperatura",
            organizationLabel: "ID da Organização",
            organizationPlaceholder: "org-...",
            activeLabel: "Ativo",
            defaultLabel: "Definir como padrão",
            capabilitiesTitle: "Capacidades de IA",
            capabilitiesDescription: "Habilite as capacidades de IA que deseja usar",
            textGenerationLabel: "Geração de Texto",
            textGenerationDescription: "Gerar texto com IA",
            translationLabel: "Tradução",
            translationDescription: "Traduzir texto entre idiomas",
            imageGenerationLabel: "Geração de Imagens",
            imageGenerationDescription: "Gerar imagens com IA",
            imageAnalysisLabel: "Análise de Imagens",
            imageAnalysisDescription: "Analisar imagens com IA",
            speechToTextLabel: "Voz para Texto",
            speechToTextDescription: "Converter áudio para texto",
            pricingTitle: "Preço de Créditos",
            pricingDescription: "Definir custos de tokens para cada capacidade",
            pricingTextLabel: "Texto (por solicitação)",
            pricingTranslationLabel: "Tradução (por solicitação)",
            pricingImageGenerationLabel: "Geração de Imagens",
            pricingImageAnalysisLabel: "Análise de Imagem (por solicitação)",
            pricingSpeechToTextLabel: "Voz para Texto (por minuto)"
          },
          delete: {
            title: "Excluir Provedor",
            message: "Tem certeza de que deseja excluir este provedor? Esta ação não pode ser desfeita."
          },
          buttons: {
            reload: "Recarregar",
            addProvider: "Adicionar Provedor",
            createFirst: "Crie seu primeiro provedor",
            cancel: "Cancelar",
            save: "Salvar Alterações",
            create: "Criar Provedor",
            delete: "Excluir"
          }
        },
        subplans: {
          title: "Planos de Tokens de IA",
          description: "Gerenciar planos de tokens de IA",
          stats: {
            total: "Total de Planos",
            active: "Ativos",
            public: "Públicos",
            totalTokens: "Total de Tokens"
          },
          table: {
            title: "Planos",
            empty: "Nenhum plano configurado",
            name: "Nome",
            tokens: "Tokens",
            used: "Usados",
            remaining: "Restantes",
            price: "Preço",
            active: "Ativo",
            public: "Público",
            actions: "Ações",
            yes: "Sim",
            no: "Não"
          },
          pagination: {
            showing: "Mostrando {current} de {total}",
            previous: "Anterior",
            next: "Próximo",
            page: "Página {current} de {total}"
          },
          modal: {
            titleCreate: "Novo Plano",
            titleEdit: "Editar Plano",
            nameLabel: "Nome do Plano",
            namePlaceholder: "ex., Plano 500 Tokens",
            descriptionLabel: "Descrição",
            descriptionPlaceholder: "Descrição opcional",
            tokensSection: "Configurações de Tokens",
            tokensLabel: "Quantidade de Tokens",
            priceLabel: "Preço (USD)",
            maxAgentsLabel: "Limite de Agentes IA",
            optionsSection: "Opções",
            activeLabel: "Ativo",
            activeHelper: "Tornar este plano disponível",
            publicLabel: "Público",
            publicHelper: "Visível para empresas comprarem"
          },
          validation: {
            nameRequired: "O nome é obrigatório",
            nameLength: "O nome não pode exceder 100 caracteres",
            descriptionLength: "A descrição não pode exceder 500 caracteres",
            tokensRequired: "A quantidade de tokens é obrigatória",
            tokensInvalid: "Os tokens devem ser um inteiro válido",
            tokensMin: "Os tokens devem ser maiores que 0",
            tokensMax: "Os tokens não podem exceder 1.000.000",
            priceInvalid: "O preço deve ser um número válido",
            priceMin: "O preço deve ser maior que 0",
            priceMax: "O preço não pode exceder 99999.99",
            priceDecimals: "O preço pode ter até 2 casas decimais"
          },
          toasts: {
            createSuccess: "Plano criado com sucesso",
            updateSuccess: "Plano atualizado com sucesso",
            deleteSuccess: "Plano excluído com sucesso",
            errorLoading: "Erro ao carregar planos",
            errorSaving: "Erro ao salvar plano",
            errorDeleting: "Erro ao excluir plano"
          },
          delete: {
            title: "Excluir Plano",
            message: "Tem certeza de que deseja excluir este plano? Esta ação não pode ser desfeita."
          },
          buttons: {
            reload: "Recarregar",
            new: "Novo Plano",
            createFirst: "Crie seu primeiro plano",
            cancel: "Cancelar",
            save: "Salvar Alterações",
            create: "Criar Plano",
            delete: "Excluir"
          }
        }
      }
    },
  },
};

class I18n {
  constructor() {
    // Default: Spanish (es)
    this.language = localStorage.getItem("i18nextLng") || "es";
  }

  t(key) {
    const keys = key.split(".");
    let value = messages[this.language]?.translations;

    for (const k of keys) {
      value = value?.[k];
      if (!value) break;
    }

    return value || key;
  }
}

export const i18n = new I18n();
